/**
 * internal dependencies
 */
import { IPinPool } from '../../../../models/cardgroup.interface';
import { PIN_POOL_FORM } from '../form-cardgroup-types';
import { showToast } from '../../../../components/toasts';

/**
 * Export the pin/vehicle pool data to CSV
 * 
 * @param data the data to export to CSV
 */
const ExportCsv = (data: IPinPool, title: string) => {
  const { cardGroup, pinPool: { pins } } = data.body;
  const { customerName, cardGroupName } = cardGroup;
  console.log(data);

  if ( !Array.isArray(pins) || pins.length === 0 ) {
    showToast('aafp_toast-alert', 'No data to export');
    PIN_POOL_FORM.ppExport.classList.remove('aafp_button-loading');
  } else {
    const d = new Date();
    const month = (d.getMonth() + 1);
    const day = (d.getDate());
    const year = d.getFullYear();

    const fileName = `${title}_${customerName}_${cardGroupName}_${year}${month}${day}`;
    const formattedFileName = fileName.replace(/[^\w]/g, '');

    const replacer = (key: any, value: any) => value === null ? '' : value;
    
    const customHeaders = ['Pin Number', 'Pin Description']; 
    const originalHeaders = Object.keys(pins[0]).filter(header => header !== 'validate');

    const headerMap = originalHeaders.reduce((acc, header, index) => {
      acc[header] = customHeaders[index] || header;
      return acc;
    }, {} as { [key: string]: string });
    
    const csvString = [
        customHeaders.join(','), 
      ...pins.map((row: any) => originalHeaders.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','))
    ].join('\r\n');

    const hiddenElement = document.createElement('a');  
    hiddenElement.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(csvString));
    hiddenElement.target = '_blank';        
    hiddenElement.setAttribute('download', formattedFileName + '.csv');  
    hiddenElement.click();
  }

  PIN_POOL_FORM.ppExport.classList.remove('aafp_button-loading');
};

export default ExportCsv;